import _ from '@lodash';
import React, { useRef } from 'react';

function useDebounce(func, wait, options) {
  return useRef(_.debounce(func, wait, options)).current;
}

export default useDebounce;
